module.exports = __webpack_public_path__ + "images/icon/icn_copy_add-43c76839.svg";